import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";

const JobTypeList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/job-type", {
    params: {
      ...payload,
    },
  });

  const jobTypeData = data as any;

  const navigateToDetails = () => {
    navigate("/master-datas/job-types/create");
  };

  const jobTypesDisplayColumns = ["name", "enabled"];
  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Job Types",
    headerTitle: "Job Type",
    buttonTitle: "Create",
    titleBarNodes: (jobTypeData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: jobTypeData?.entityPermissions
      ? !jobTypeData?.entityPermissions?.includes("Job Type-Create")
      : false,
    subHeading: "",
    rowCount: jobTypeData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Job Types"
          data={jobTypeData?.items ?? []}
          displayColumns={jobTypesDisplayColumns}
          linkColumn="name"
          linkUrl="/master-datas/job-types"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={jobTypeData?.totalItems}
          deleteApiUrl="/job-type"
          refetchFunction={fetchData}
          disabled={
            jobTypeData?.entityPermissions
              ? !jobTypeData?.entityPermissions?.includes("Job Type-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default JobTypeList;
